import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Addon = {
  __typename?: 'Addon';
  addonId: Scalars['String'];
  addonName: Scalars['String'];
  pricingModel: Scalars['String'];
  quantity: Scalars['Int'];
  tiers?: Maybe<Array<Tier>>;
  unitPrice: Scalars['Int'];
};

export type AppPricingConfigInput = {
  Prices: Array<Price>;
  defaultPricing: Price;
  environmentName: Scalars['String'];
  workflowId: Scalars['String'];
};

export type AppPricingConfigResponse = {
  __typename?: 'AppPricingConfigResponse';
  Prices?: Maybe<Array<Maybe<AppPricingOutput>>>;
  defaultPricing?: Maybe<AppPricingOutput>;
  environmentName: Scalars['String'];
  isSuccess: Scalars['Boolean'];
  workflowId: Scalars['String'];
};

export type AppPricingOutput = {
  __typename?: 'AppPricingOutput';
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
};

export type ApplyAddonToSubscriptionInput = {
  addonId: Scalars['String'];
  currencyCode: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type ApplyAddonWithOverageInput = {
  pageSize: Scalars['Int'];
};

export type ApplyAddonWithOverageResponse = {
  __typename?: 'ApplyAddonWithOverageResponse';
  isSuccess: Scalars['Boolean'];
};

export type BillingDetails = {
  __typename?: 'BillingDetails';
  addr?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_code?: Maybe<Scalars['String']>;
};

export type CbPricingPageSessionInput = {
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type CbPricingPageSessionResponse = {
  __typename?: 'CBPricingPageSessionResponse';
  created_at: Scalars['Int'];
  expires_at: Scalars['Int'];
  id: Scalars['String'];
  object: Scalars['String'];
  url: Scalars['String'];
};

export type CbSessionInput = {
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type CbSessionLogoutInput = {
  BillingCustId?: InputMaybe<Scalars['ID']>;
  PortalSessionId: Scalars['ID'];
  SBId: Scalars['ID'];
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type CardDetails = {
  __typename?: 'CardDetails';
  card_type?: Maybe<Scalars['String']>;
  iin?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  masked_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  DiscountPercentage: Scalars['Int'];
  DiscountType: Scalars['String'];
  Name: Scalars['String'];
  Period: Scalars['Int'];
  PeriodUnit: Scalars['String'];
  Status: Scalars['String'];
  ValidTill: Scalars['Int'];
};

export type CreateBillingDetailsInput = {
  accountId: Scalars['String'];
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateBillingDetailsResponse = {
  __typename?: 'CreateBillingDetailsResponse';
  accountId: Scalars['String'];
  billingCustId: Scalars['String'];
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type Entitlement = {
  __typename?: 'Entitlement';
  feature_id: Scalars['String'];
  feature_name: Scalars['String'];
  feature_type: Scalars['String'];
  is_enabled: Scalars['Boolean'];
  is_overridden: Scalars['Boolean'];
  name: Scalars['String'];
  object: Scalars['String'];
  subscription_id: Scalars['ID'];
  value: Scalars['String'];
};

export enum EntitlementType {
  Quantity = 'QUANTITY',
  Range = 'RANGE',
  Switch = 'SWITCH'
}

export type GetAccountPriceMappingInput = {
  emailId: Scalars['String'];
  environmentName: Scalars['String'];
  pricingId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  sectionId: Scalars['String'];
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type GetAccountPriceMappingResponse = {
  __typename?: 'GetAccountPriceMappingResponse';
  emailId: Scalars['String'];
  price: AppPricingOutput;
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type GetAccountPricingDetailsInput = {
  accountId: Scalars['String'];
};

export type GetAccountPricingDetailsResponse = {
  __typename?: 'GetAccountPricingDetailsResponse';
  accountId: Scalars['String'];
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
};

export type GetAppPricingConfigRequest = {
  configurationName: Scalars['String'];
  environmentName: Scalars['String'];
  workflowId: Scalars['String'];
};

export type GetAppPricingConfigRequestv2 = {
  sectionId: Scalars['String'];
  workflowId: Scalars['String'];
};

export type GetAppPricingConfigResponse = {
  __typename?: 'GetAppPricingConfigResponse';
  Prices?: Maybe<Array<Maybe<AppPricingOutput>>>;
  defaultPricing?: Maybe<AppPricingOutput>;
  workflowId: Scalars['String'];
};

export type GetBillingDetailsResponse = {
  __typename?: 'GetBillingDetailsResponse';
  billingCustomerId: Scalars['String'];
  pricingPlanId: Scalars['String'];
  pricingPlanName: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type GetCheckoutPageUrlInput = {
  cancelUrl?: InputMaybe<Scalars['String']>;
  pricingPlanId: Scalars['String'];
  redirectUrl: Scalars['String'];
  workflowRuntimeId: Scalars['ID'];
};

export type GetCheckoutPageUrlResponse = {
  __typename?: 'GetCheckoutPageURLResponse';
  redirectUrl: Scalars['String'];
};

export type GetCheckoutUrlForExistingSubscriptionInput = {
  cancelUrl: Scalars['String'];
  redirectUrl: Scalars['String'];
};

export type GetCheckoutUrlForExistingSubscriptionResponse = {
  __typename?: 'GetCheckoutUrlForExistingSubscriptionResponse';
  url: Scalars['String'];
};

export type GetCustomerCardInfoInput = {
  customerAccountId: Scalars['ID'];
  productId: Scalars['String'];
};

export type GetCustomerCardInfoResponse = {
  __typename?: 'GetCustomerCardInfoResponse';
  CardType?: Maybe<Scalars['String']>;
  ExpiryMonth: Scalars['Int'];
  ExpiryYear: Scalars['Int'];
  FundingType?: Maybe<Scalars['String']>;
  Iin?: Maybe<Scalars['String']>;
  Last4?: Maybe<Scalars['String']>;
  MaskedNumber?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
};

export type GetCustomerRequestInput = {
  customerAccountId: Scalars['ID'];
  productId: Scalars['String'];
};

export type GetCustomerResponse = {
  __typename?: 'GetCustomerResponse';
  addr?: Maybe<Scalars['String']>;
  billing?: Maybe<BillingDetails>;
  card?: Maybe<CardDetails>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferred_currency_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_code?: Maybe<Scalars['String']>;
};

export type GetEntitlementInput = {
  productId: Scalars['ID'];
};

export type GetPricingDetailsForProductInput = {
  thriveStackProductName: ThriveStackProductName;
};

export type GetPricingDetailsForProductResponse = {
  __typename?: 'GetPricingDetailsForProductResponse';
  appliedAddons?: Maybe<Array<Addon>>;
  availableAddons?: Maybe<Array<Addon>>;
  plans?: Maybe<Array<PlanDetails>>;
};

export type GetShippingAddressRequestInput = {
  customerAccountId: Scalars['ID'];
  productId: Scalars['String'];
};

export type GetShippingAddressResponse = {
  __typename?: 'GetShippingAddressResponse';
  addr?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_code?: Maybe<Scalars['String']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amountDue: Scalars['Int'];
  amountPaid: Scalars['Int'];
  downloadURL: Scalars['String'];
  dueDate: Scalars['Int'];
  invoiceNumber?: Maybe<Scalars['String']>;
  issueDate: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
};

export type IsCheckoutRequiredInput = {
  pricingPlanId?: InputMaybe<Scalars['String']>;
};

export type IsCheckoutRequiredResponse = {
  __typename?: 'IsCheckoutRequiredResponse';
  isRequired: Scalars['Boolean'];
};

export type IsSuccessResponse = {
  __typename?: 'IsSuccessResponse';
  isSuccess: Scalars['Boolean'];
};

export type ListInvoicesRequestInput = {
  customerAccountId: Scalars['ID'];
  productId: Scalars['String'];
};

export type ListInvoicesResponse = {
  __typename?: 'ListInvoicesResponse';
  invoices?: Maybe<Array<Maybe<Invoice>>>;
};

export type ListSubscriptionsInput = {
  pageSize: Scalars['Int'];
};

export type ListSubscriptionsResponse = {
  __typename?: 'ListSubscriptionsResponse';
  subscriptionStatus?: Maybe<Array<Maybe<SubscriptionWithStatus>>>;
};

export type MonthlyUsage = {
  __typename?: 'MonthlyUsage';
  available: Scalars['Int'];
  consumed: Scalars['Int'];
  limit: Scalars['Int'];
  month: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  applyAddonToSubscription: IsSuccessResponse;
  createBillingDetails: CreateBillingDetailsResponse;
  getAccountPriceMapping: GetAccountPriceMappingResponse;
  removeAddonForSubscription: IsSuccessResponse;
  startTrialForProduct: IsSuccessResponse;
  storeAppPricingConfig: AppPricingConfigResponse;
  updateCustomerAccount: UpdateCustomerAccountResponse;
  updateCustomerBillingAddress: UpdateCustomerBillingAddrResponse;
  updateCustomerShippingAddress: UpdateCustomerShippingAddrResponse;
};


export type MutationApplyAddonToSubscriptionArgs = {
  input: ApplyAddonToSubscriptionInput;
};


export type MutationCreateBillingDetailsArgs = {
  input: CreateBillingDetailsInput;
};


export type MutationGetAccountPriceMappingArgs = {
  input: GetAccountPriceMappingInput;
};


export type MutationRemoveAddonForSubscriptionArgs = {
  input: RemoveAddonForSubscriptionInput;
};


export type MutationStartTrialForProductArgs = {
  input: StartTrialForProduct;
};


export type MutationStoreAppPricingConfigArgs = {
  input: AppPricingConfigInput;
};


export type MutationUpdateCustomerAccountArgs = {
  input?: InputMaybe<UpdateCustomerAccountReqInput>;
};


export type MutationUpdateCustomerBillingAddressArgs = {
  input?: InputMaybe<UpdateCustomerBillingAddrReqInput>;
};


export type MutationUpdateCustomerShippingAddressArgs = {
  input?: InputMaybe<UpdateCustomerShippingAddrReqInput>;
};

export type PlanDetails = {
  __typename?: 'PlanDetails';
  isApplied: Scalars['Boolean'];
  planId: Scalars['String'];
  planName: Scalars['String'];
  planPriceId: Scalars['String'];
  planPriceName: Scalars['String'];
  pricingModel: Scalars['String'];
  quantity: Scalars['Int'];
  tiers?: Maybe<Array<Tier>>;
  trialEnds: Scalars['Int'];
  unitPrice: Scalars['Int'];
};

export type PortalSessionResponse = {
  __typename?: 'PortalSessionResponse';
  access_url: Scalars['String'];
  created_at: Scalars['Int'];
  customer_id: Scalars['String'];
  expires_at: Scalars['Int'];
  id: Scalars['ID'];
  object: Scalars['String'];
  status: Scalars['String'];
  token: Scalars['String'];
};

export type Price = {
  PriceId: Scalars['String'];
  PriceName: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  GetCheckoutPageURLForNewSub: GetCheckoutPageUrlResponse;
  applyAddonWithOverageEmail: ApplyAddonWithOverageResponse;
  getAccountPricingDetails: GetAccountPricingDetailsResponse;
  getAppPricingConfigv2: GetAppPricingConfigResponse;
  getCheckoutUrlForExistingSubscription: GetCheckoutUrlForExistingSubscriptionResponse;
  getCustomerAccountDetails: GetCustomerResponse;
  getCustomerCardInfo: GetCustomerCardInfoResponse;
  getEntitlements: SubscriptionEntitlementResponse;
  getEntitlementsWithUsage: UsageEntitlementsResponse;
  getFeatureUsageById: UsageByFeatureIdResponse;
  getFeatureUsageTrend: UsageTrendResponse;
  getPortalSession: PortalSessionResponse;
  getPricingDetailsForProduct: GetPricingDetailsForProductResponse;
  getPricingPageSession: CbPricingPageSessionResponse;
  getShippingAddressDetails: GetShippingAddressResponse;
  getSubscription: SubscriptionResponse;
  isCheckoutRequired: IsCheckoutRequiredResponse;
  listInvoices: ListInvoicesResponse;
  listSubscriptions: ListSubscriptionsResponse;
  logOutPortalSession: PortalSessionResponse;
  retrieveSubscriptionPricing: SubscriptionPricingResponse;
  updateSubscriptionForProduct: UpdateSubscriptionForProductResponse;
};


export type QueryGetCheckoutPageUrlForNewSubArgs = {
  input?: InputMaybe<GetCheckoutPageUrlInput>;
};


export type QueryApplyAddonWithOverageEmailArgs = {
  input?: InputMaybe<ApplyAddonWithOverageInput>;
};


export type QueryGetAccountPricingDetailsArgs = {
  input: GetAccountPricingDetailsInput;
};


export type QueryGetAppPricingConfigv2Args = {
  input: GetAppPricingConfigRequestv2;
};


export type QueryGetCheckoutUrlForExistingSubscriptionArgs = {
  input: GetCheckoutUrlForExistingSubscriptionInput;
};


export type QueryGetCustomerAccountDetailsArgs = {
  input?: InputMaybe<GetCustomerRequestInput>;
};


export type QueryGetCustomerCardInfoArgs = {
  input?: InputMaybe<GetCustomerCardInfoInput>;
};


export type QueryGetEntitlementsArgs = {
  input: GetEntitlementInput;
};


export type QueryGetEntitlementsWithUsageArgs = {
  input?: InputMaybe<UsageEntitlementsInput>;
};


export type QueryGetFeatureUsageByIdArgs = {
  input?: InputMaybe<UsageByFeatureIdInput>;
};


export type QueryGetFeatureUsageTrendArgs = {
  input?: InputMaybe<UsageTrendInput>;
};


export type QueryGetPortalSessionArgs = {
  input: CbSessionInput;
};


export type QueryGetPricingDetailsForProductArgs = {
  input: GetPricingDetailsForProductInput;
};


export type QueryGetPricingPageSessionArgs = {
  input: CbPricingPageSessionInput;
};


export type QueryGetShippingAddressDetailsArgs = {
  input?: InputMaybe<GetShippingAddressRequestInput>;
};


export type QueryGetSubscriptionArgs = {
  input: SubscriptionInput;
};


export type QueryIsCheckoutRequiredArgs = {
  input: IsCheckoutRequiredInput;
};


export type QueryListInvoicesArgs = {
  input?: InputMaybe<ListInvoicesRequestInput>;
};


export type QueryListSubscriptionsArgs = {
  input?: InputMaybe<ListSubscriptionsInput>;
};


export type QueryLogOutPortalSessionArgs = {
  input: CbSessionLogoutInput;
};


export type QueryRetrieveSubscriptionPricingArgs = {
  input: SubscriptionPricingInput;
};


export type QueryUpdateSubscriptionForProductArgs = {
  input: UpdateSubscriptionForProductInput;
};

export type RemoveAddonForSubscriptionInput = {
  addonId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type StartTrialForProduct = {
  thriveStackProductName: ThriveStackProductName;
};

export type SubscriptionEntitlementResponse = {
  __typename?: 'SubscriptionEntitlementResponse';
  entitlements?: Maybe<Array<Entitlement>>;
};

export type SubscriptionInput = {
  billingCustId?: InputMaybe<Scalars['ID']>;
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type SubscriptionPricingInput = {
  customerAccountId: Scalars['ID'];
  environmentId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type SubscriptionPricingResponse = {
  __typename?: 'SubscriptionPricingResponse';
  amount: Scalars['Int'];
  billing_cycles: Scalars['Int'];
  billing_period?: Maybe<Scalars['Int']>;
  billing_period_unit: Scalars['String'];
  coupons?: Maybe<Array<Maybe<Coupon>>>;
  currency_code: Scalars['String'];
  current_term_end: Scalars['Int'];
  current_term_start: Scalars['Int'];
  id: Scalars['ID'];
  next_billing_at: Scalars['Int'];
  plan_name: Scalars['String'];
  purchasedMtus: Scalars['Int'];
  startDate: Scalars['Int'];
  subscription_id: Scalars['String'];
  trial_end: Scalars['Int'];
  trial_start: Scalars['Int'];
  unit_price: Scalars['String'];
};

export type SubscriptionResponse = {
  __typename?: 'SubscriptionResponse';
  billing_period?: Maybe<Scalars['Int']>;
  billing_period_unit?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Int']>;
  created_from_ip?: Maybe<Scalars['String']>;
  currency_code?: Maybe<Scalars['String']>;
  current_term_end?: Maybe<Scalars['Int']>;
  current_term_start?: Maybe<Scalars['Int']>;
  customer_id?: Maybe<Scalars['ID']>;
  deleted?: Maybe<Scalars['Boolean']>;
  has_scheduled_changes?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  item_price_id?: Maybe<Scalars['String']>;
  item_type?: Maybe<Scalars['String']>;
  next_billing_at?: Maybe<Scalars['Int']>;
  resource_version?: Maybe<Scalars['Float']>;
  started_at?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trial_end?: Maybe<Scalars['Int']>;
  trial_start?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['Int']>;
};

export type SubscriptionWithStatus = {
  __typename?: 'SubscriptionWithStatus';
  billingPeriodUnit: Scalars['String'];
  status: Scalars['String'];
  subscription_id: Scalars['ID'];
};

export type SubscriptionWithStatusInput = {
  status: Scalars['String'];
  subscription_id: Scalars['ID'];
};

export enum ThriveStackProductName {
  CustomerAnalytics = 'CustomerAnalytics'
}

export type Tier = {
  __typename?: 'Tier';
  endingUnit: Scalars['Int'];
  price: Scalars['Int'];
  startingUnit: Scalars['Int'];
};

export type UpdateCustomerAccountReqInput = {
  Company?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  ProductId: Scalars['String'];
  customerAccountId: Scalars['ID'];
};

export type UpdateCustomerAccountResponse = {
  __typename?: 'UpdateCustomerAccountResponse';
  IsSuccess: Scalars['Boolean'];
};

export type UpdateCustomerBillingAddrReqInput = {
  AddressLine1?: InputMaybe<Scalars['String']>;
  AddressLine2?: InputMaybe<Scalars['String']>;
  City?: InputMaybe<Scalars['String']>;
  Company?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  ProductId: Scalars['String'];
  State?: InputMaybe<Scalars['String']>;
  StateCode?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
  customerAccountId: Scalars['ID'];
};

export type UpdateCustomerBillingAddrResponse = {
  __typename?: 'UpdateCustomerBillingAddrResponse';
  IsSuccess: Scalars['Boolean'];
};

export type UpdateCustomerShippingAddrReqInput = {
  City?: InputMaybe<Scalars['String']>;
  Company?: InputMaybe<Scalars['String']>;
  Country?: InputMaybe<Scalars['String']>;
  Email?: InputMaybe<Scalars['String']>;
  ExtendedAddr1?: InputMaybe<Scalars['String']>;
  ExtendedAddr2?: InputMaybe<Scalars['String']>;
  FirstName?: InputMaybe<Scalars['String']>;
  LastName?: InputMaybe<Scalars['String']>;
  Phone?: InputMaybe<Scalars['String']>;
  ProductId: Scalars['String'];
  State?: InputMaybe<Scalars['String']>;
  StateCode?: InputMaybe<Scalars['String']>;
  Zip?: InputMaybe<Scalars['String']>;
  customerAccountId: Scalars['ID'];
};

export type UpdateCustomerShippingAddrResponse = {
  __typename?: 'UpdateCustomerShippingAddrResponse';
  IsSuccess: Scalars['Boolean'];
};

export type UpdateSubscriptionForProductInput = {
  existingSubscriptionId: Scalars['String'];
  productId: Scalars['String'];
  subscriptionId: Scalars['String'];
};

export type UpdateSubscriptionForProductResponse = {
  __typename?: 'UpdateSubscriptionForProductResponse';
  isSuccess: Scalars['Boolean'];
};

export type UsageByFeatureIdInput = {
  featureId: Scalars['ID'];
  organizationId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type UsageByFeatureIdResponse = {
  __typename?: 'UsageByFeatureIdResponse';
  featureId: Scalars['ID'];
  featureName: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  limit: Scalars['Int'];
  module: Scalars['String'];
  remaining: Scalars['Int'];
  type: EntitlementType;
  unit: Scalars['String'];
  used: Scalars['Int'];
};

export type UsageEntitlement = {
  __typename?: 'UsageEntitlement';
  featureId: Scalars['ID'];
  featureName: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  limit: Scalars['Int'];
  module?: Maybe<Scalars['String']>;
  remaining: Scalars['Int'];
  type: EntitlementType;
  unit: Scalars['String'];
  used: Scalars['Int'];
};

export type UsageEntitlementsInput = {
  endDate: Scalars['Int'];
  organizationId: Scalars['ID'];
  planId: Scalars['ID'];
  productId: Scalars['ID'];
  startDate: Scalars['Int'];
  subscriptionId: Scalars['ID'];
};

export type UsageEntitlementsResponse = {
  __typename?: 'UsageEntitlementsResponse';
  data: Array<UsageEntitlement>;
};

export type UsageTrendInput = {
  endDate: Scalars['Int'];
  environmentId: Scalars['ID'];
  featureId: Scalars['ID'];
  organizationId: Scalars['ID'];
  productId: Scalars['ID'];
  startDate: Scalars['Int'];
};

export type UsageTrendResponse = {
  __typename?: 'UsageTrendResponse';
  data: Array<MonthlyUsage>;
  featureId: Scalars['ID'];
  featureName: Scalars['String'];
};

export type UserPriceMappingInput = {
  emailId: Scalars['String'];
  environmentName: Scalars['String'];
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type UserPriceMappingInputv2 = {
  emailId: Scalars['String'];
  environmentName: Scalars['String'];
  pricingId?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  sectionId: Scalars['String'];
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type UserPriceMappingResponse = {
  __typename?: 'UserPriceMappingResponse';
  emailId: Scalars['String'];
  price: AppPricingOutput;
  workflowId: Scalars['String'];
  workflowRuntimeId: Scalars['String'];
};

export type GetEntitlementsQueryVariables = Exact<{
  input: GetEntitlementInput;
}>;


export type GetEntitlementsQuery = { __typename?: 'Query', getEntitlements: { __typename?: 'SubscriptionEntitlementResponse', entitlements?: Array<{ __typename?: 'Entitlement', subscription_id: string, feature_id: string, feature_name: string, feature_type: string, value: string, name: string, is_overridden: boolean, is_enabled: boolean, object: string }> | null } };


export const GetEntitlementsDocument = gql`
    query GetEntitlements($input: GetEntitlementInput!) {
  getEntitlements(input: $input) {
    entitlements {
      subscription_id
      feature_id
      feature_name
      feature_type
      value
      name
      is_overridden
      is_enabled
      object
    }
  }
}
    `;

/**
 * __useGetEntitlementsQuery__
 *
 * To run a query within a React component, call `useGetEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntitlementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEntitlementsQuery(baseOptions: Apollo.QueryHookOptions<GetEntitlementsQuery, GetEntitlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntitlementsQuery, GetEntitlementsQueryVariables>(GetEntitlementsDocument, options);
      }
export function useGetEntitlementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntitlementsQuery, GetEntitlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntitlementsQuery, GetEntitlementsQueryVariables>(GetEntitlementsDocument, options);
        }
export type GetEntitlementsQueryHookResult = ReturnType<typeof useGetEntitlementsQuery>;
export type GetEntitlementsLazyQueryHookResult = ReturnType<typeof useGetEntitlementsLazyQuery>;
export type GetEntitlementsQueryResult = Apollo.QueryResult<GetEntitlementsQuery, GetEntitlementsQueryVariables>;